import * as types from '../services/leadershipBulkUpdateActionType';

//Rad Leadership Actions - start
export const fetchRadLeadershipRequest = () => ({
    type: types.FETCH_RAD_LEADERSHIP_REQUEST
});
export const fetchRadLeadershipSuccess = (data) => ({
    type: types.FETCH_RAD_LEADERSHIP_SUCCESS,
    payload: data
});
export const fetchRadLeadershipFailure = (error) => ({
    type: types.FETCH_RAD_LEADERSHIP_FAILURE,
    payload: error
});
 
export const radLeadershipBulkUpdateRequest = (data) => ({
    type: types.RAD_LEADERSHIP_BULK_UPDATE_REQUEST,
    payload: data
});
export const radLeadershipBulkUpdateSuccess = (data) => ({
    type: types.RAD_LEADERSHIP_BULK_UPDATE_SUCCESS,
    payload: data
});
export const radLeadershipBulkUpdateFailure = (error) => ({
    type: types.RAD_LEADERSHIP_BULK_UPDATE_FAILURE,
    payload: error
});
 
export const checkRadLeadershipEditAccessRequest = (userId) => ({
    type: types.CHECK_RAD_LEADERSHIP_EDIT_ACCESS_REQUEST,
    payload: userId
});
export const checkRadLeadershipEditAccessSuccess = (data) => ({
    type: types.CHECK_RAD_LEADERSHIP_EDIT_ACCESS_SUCCESS,
    payload: data
});
export const checkRadLeadershipEditAccessFailure = (error) => ({
    type: types.CHECK_RAD_LEADERSHIP_EDIT_ACCESS_FAILURE,
    payload: error
});
 
export const deleteRadLeadershipBulkUpdateUserRequest = (userId) => ({
    type: types.DELETE_RAD_LEADERSHIP_BULK_UPDATE_USER_REQUEST,
    payload: userId
});
export const deleteRadLeadershipBulkUpdateUserSuccess = (data) => ({
    type: types.DELETE_RAD_LEADERSHIP_BULK_UPDATE_USER_SUCCESS,
    payload: data
});
export const deleteRadLeadershipBulkUpdateUserFailure = (error) => ({
    type: types.DELETE_RAD_LEADERSHIP_BULK_UPDATE_USER_FAILURE,
    payload: error
});
 
export const resetRadLeadershipEditAccess = () => ({
    type: types.RESET_RAD_LEADERSHIP_EDIT_ACCESS
});
//Rad Leadership Actions - end